import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import PainelLancamentos from '../components/PainelLancamentos';

const token = () => localStorage.getItem('token');
const apiGet = (p) => fetch(`/${p}${p.includes('?') ? '&' : '?'}_=${Date.now()}`, { headers: { Authorization: `Bearer ${token()}`, 'Cache-Control': 'no-cache' } }).then(r => r.json());
const apiSend = (p, m, b) => fetch(`/${p}`, { method: m, headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` }, body: b ? JSON.stringify(b) : undefined }).then(r => r.json());

const inp = { padding: '4px 8px', borderRadius: 3, border: '1px solid #b0b8c4', fontSize: 13, color: '#111', background: '#fff', height: 30, outline: 'none', width: '100%', boxSizing: 'border-box' };
const lbl = { fontSize: 11, fontWeight: 600, color: '#6b7280', display: 'block', marginBottom: 2 };

const CAMPOS_ID = [
  ['nome', 'Nome / Fantasia', 3], ['razao_social', 'Razão Social', 3],
  ['cnpj', 'CNPJ', 2], ['cpf', 'CPF', 2], ['inscricao_estadual', 'Inscrição Estadual', 2], ['inscricao_municipal', 'Inscrição Municipal', 2],
  ['telefone', 'Telefone', 2], ['email', 'E-mail', 2], ['email_financeiro', 'E-mail Financeiro', 2], ['responsavel', 'Contato / Responsável', 2],
  ['cep', 'CEP', 1], ['rua', 'Rua', 3], ['numero', 'Número', 1], ['complemento', 'Complemento', 2],
  ['bairro', 'Bairro', 2], ['cidade', 'Cidade', 2], ['estado', 'UF', 1],
  ['banco', 'Banco', 2], ['agencia', 'Agência', 1], ['conta', 'Conta', 1], ['pix', 'Chave PIX', 2],
];

export default function FormFornecedor() {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const editando = Boolean(id);
  const abaInicial = new URLSearchParams(location.search).get('aba') === 'financeiro' ? 'financeiro' : 'identificacao';
  const [aba, setAba] = useState(abaInicial);
  const [form, setForm] = useState({});
  const [salvando, setSalvando] = useState(false);
  const [salvo, setSalvo] = useState('');

  useEffect(() => {
    if (!editando) return;
    apiGet(`fornecedores/${id}`).then(f => { if (f && !f.erro) setForm(f); }).catch(() => {});
  }, [id, editando]);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const salvar = async () => {
    if (!form.nome && !form.razao_social) return alert('Informe o nome ou a razão social.');
    setSalvando(true);
    if (editando) { await apiSend(`fornecedores/${id}`, 'PUT', form); setSalvo('Salvo!'); setTimeout(() => setSalvo(''), 1500); }
    else {
      const r = await apiSend('fornecedores', 'POST', form);
      if (r.id) navigate(`/fornecedores/${r.id}/editar`, { replace: true });
    }
    setSalvando(false);
  };

  return (
    <div style={{ padding: 4, maxWidth: 1000 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <div>
          <button onClick={() => navigate('/fornecedores')} style={{ background: 'none', border: 'none', color: '#6b7280', fontSize: 12, cursor: 'pointer', padding: 0 }}>← Fornecedores</button>
          <h1 style={{ fontSize: 16, fontWeight: 700, color: '#0a1628', margin: '2px 0 0' }}>{editando ? (form.nome || form.razao_social || 'Fornecedor') : 'Novo Fornecedor'}</h1>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {salvo && <span style={{ fontSize: 12, color: '#16a34a', fontWeight: 600 }}>{salvo}</span>}
          <button onClick={salvar} disabled={salvando} style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 4, padding: '6px 18px', fontSize: 13, fontWeight: 600, cursor: 'pointer', opacity: salvando ? 0.6 : 1 }}>{salvando ? 'Salvando...' : editando ? 'Salvar' : 'Cadastrar'}</button>
        </div>
      </div>

      {/* Abas */}
      <div style={{ display: 'flex', borderBottom: '2px solid #0a1628' }}>
        {[{ k: 'identificacao', l: 'Identificação' }, { k: 'financeiro', l: 'Financeiro' }].map(t => (
          <button key={t.k} onClick={() => setAba(t.k)} style={{
            padding: '6px 18px', fontSize: 13, fontWeight: 600, border: 'none', cursor: 'pointer', borderRadius: '6px 6px 0 0',
            color: aba === t.k ? '#fff' : '#374151', background: aba === t.k ? '#0a1628' : '#e5e7eb',
          }}>{t.l}</button>
        ))}
      </div>

      {aba === 'identificacao' && (
        <div style={{ background: '#fff', border: '1px solid #c8d0da', borderTop: 'none', padding: 14 }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
            {CAMPOS_ID.map(([k, label, flex]) => (
              <div key={k} style={{ flex, minWidth: 120 }}>
                <label style={lbl}>{label}</label>
                <input value={form[k] || ''} onChange={set(k)} style={inp} />
              </div>
            ))}
          </div>
          <div style={{ marginTop: 10 }}>
            <label style={lbl}>Observações</label>
            <textarea value={form.observacao || ''} onChange={set('observacao')} rows={2} style={{ ...inp, height: 'auto', resize: 'vertical' }} />
          </div>
        </div>
      )}

      {aba === 'financeiro' && (
        <div style={{ background: '#fff', border: '1px solid #c8d0da', borderTop: 'none', padding: 14 }}>
          {!editando ? (
            <div style={{ color: '#6b7280', fontSize: 13 }}>Salve o fornecedor primeiro (aba Identificação) para lançar contas a pagar.</div>
          ) : (
            <PainelLancamentos tipo="pagar" idField="fornecedor_id" idValue={id} nomeValue={form.nome || form.razao_social || ''} />
          )}
        </div>
      )}
    </div>
  );
}
